import { render } from "./Revoke.vue?vue&type=template&id=bde63052&scoped=true&ts=true"
import script from "./Revoke.vue?vue&type=script&lang=ts"
export * from "./Revoke.vue?vue&type=script&lang=ts"

import "./Revoke.vue?vue&type=style&index=0&id=bde63052&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde63052"]])

export default __exports__